import { editOrderOffer } from '../../../hooks/apiAxios';
import SuccessErrorMsg from "../../../utilities/SuccessErrorMsg"
import { handleFileChange } from "../../../utilities/handleFunctions/HandleFileUpload"
import { ToastContainer, toast } from "react-toastify";

export default function NotSuperAdminOfferDetails({ offerStatus, orderId, loading, setLoading, setValue, handleSubmit, setError, errors, register, orderStatus }) {

    async function onSubmit(formData) {
        setLoading(true);
        try {
            const response = await editOrderOffer(orderId, formData);

            if (response.data.isSuccess) {
                toast.success("تم إرسال العرض ..")
                setTimeout(() => {
                    window.location.reload();
                }, 3000);

            } else {
                toast.error("حدث خطأ ما، تواصل مع الدعم");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            // toast.warn("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }

    return (<>
        {(orderStatus[2] === "معتمد" || orderStatus[2] === "تم الدفع") ? "" :
            <form className='d-flex flex-wrap text-start pe-5 ps-3 pb-4 gap-1'
                onSubmit={handleSubmit(onSubmit)}>
                <div className="input-group input-group-sm">
                    <span className="input-group-text" >السعر</span>
                    <input
                        placeholder='ضع السعر شامل الضريبة'
                        className='form-control form-control-sm text-start'
                        type="number" step="any"
                        {...register("price", { required: true })} />
                    {errors.email && <p className='errors-msg'>√</p>}
                </div>
                <div className="input-group input-group-sm">
                    <span className="input-group-text" >العرض</span>
                    <input className="form-control form-control-sm" type="file" accept=".pdf"
                        required
                        onChange={(e) => handleFileChange(e, setValue, setError)}
                    />
                    {errors.file && <p className='errors-msg'>أضف ملف العرض</p>}
                </div>
                <div className="input-group input-group-sm w-100 ">
                    <span className="input-group-text" >ملاحظات</span>
                    <input
                        className='form-control form-control-sm '
                        type="text"
                        {...register("notes", { required: true })} />
                </div>
                <div className="dinput-group input-group-sm w-100">
                    <span className="input-group-text">الحالة</span>
                    <input className='form-control form-control-sm' disabled
                        // {...register("status")}
                        defaultValue={offerStatus} />
                </div>
                <button
                    className='btn-masar btn-dark-orange text-white col-2 ms-auto my-2 float-end'
                    type="submit">
                    {loading &&
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                    }
                    تحديث
                </button>
                <SuccessErrorMsg
                    ToastContainer={ToastContainer}
                />
            </form>}
    </>
    )
}